import content, { getProductBySlug } from '../../content.js'
import AppProductsSlideshow from '../app-products-slideshow'
import { scrollTo } from '../utils/easeScrollTo'
import Shopify from '../utils/Shopify.js'
import AppAddCart from '../app-add-cart'
import easeScrollTo from '../utils/easeScrollTo'
import AppParallax from '../app-parallax'
import AppParallaxImg from '../app-parallax-img'
import MixinResize from '../mixin-resize'

const shopify = new Shopify()

export default
{
    mixins: [
        MixinResize
    ],

    components: {
        AppAddCart,
        AppProductsSlideshow,
        AppParallax,
        AppParallaxImg
    },

    props: {
        params: { type: Object, default: {  } }
    },

    data()
    {
        return {
            product: getProductBySlug(this.params.slug),
            others: [],
            item: {},
            detailsModal: null
        }
    },

    watch:
    {
        params()
        {
            this.init()
        },

        item()
        {
            this.resize.dispatch()
        }
    },

    created()
    {
        this.init()
    },

    destroyed()
    {
        window.document.body.classList.remove('is-modal-open')
    },

    methods:
    {
        onResized()
        {
            // Hide warning
        },

        detailsModalToggle(content = null, label = null)
        {
            const contentClean = content ? JSON.parse(JSON.stringify(content)) : null

            if (label && contentClean)
            {
                contentClean._label = label
            }

            this.detailsModal = contentClean

            if (contentClean)
            {
                window.document.body.classList.add('is-modal-open')
            }
            else
            {
                window.document.body.classList.remove('is-modal-open')
            }
        },

        init()
        {
            this.product = getProductBySlug(this.params.slug)
            this.others = JSON.parse(JSON.stringify(content.products.filter(({ name }) => name !== this.product.name)))
            this.item = shopify.getProductBySlug(this.params.slug, item => this.item = JSON.parse(JSON.stringify(item)))
            scrollTo(0)
        },

        addProductToCart()
        {
            shopify.getProductBySlug(this.product.slug, product =>
            {
                shopify.addItemsToCart(product.variants[0].id, 1)
            })
        },

        scrollTo(refName)
        {
            const y = this.$refs[refName][0].offsetTop
            easeScrollTo(y)
        }
    }
}